import React from 'react'
import CheckedText from "./CheckedText"
import Container from "../Layout/Container"
import Button from "./Button"
import Title from "./Title"
import styled from 'styled-components'

const Activities = () => {
  return (
    <div style={{ background: "#2B3D6B"}}>
      <Container maxWidth={800} >
        <div style={{ padding: "50px 0", textAlign: "center"}}>
          <Title style={{ color: "#FFF"}}>
            Algunas actividades del programa
          </Title>
          <div style={{ textAlign: "left"}}>
            <CheckedText style={{ marginTop: '50px'}}>
              El problema no es costar más, sino que los clientes no entiendan por qué.
            </CheckedText>
            <CheckedText style={{ marginTop: '50px'}}>
              No cometas estos errores cuando hables de precios con tus clientes.
            </CheckedText>
            <CheckedText style={{ marginTop: '50px'}}>
              Lo bueno, lo malo y lo feo de trabajar como médico veterinario en Estados unidos.
            </CheckedText>
            <CheckedText style={{ marginTop: '50px'}}>
              Las claves para ofrecer descuentos y promociones y que sean rentables.
            </CheckedText>
          </div>
      </div>
      <ButtonWrapper className="flex flex-row justify-center mt-14">
        <a href='https://trazoevents.com/landing/veterinario-colchagua-2022/program' target='_blank'>
          <Button buttonText="Ver programa de actividades"/>
        </a>
      </ButtonWrapper>
      </Container>
    </div>
  )
}

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  marginTop: 50px;
  padding-bottom: 50px;
`

export default Activities
